import React, { useMemo } from 'react';
import { useUser } from '../utils/UserContext';
import { itemVisible } from '../data/map';
import { availableShelvesForUser } from '../data/videoAvailableLibrary';
import VideoShelf from './VideoShelf';

/*
 * VideoAvailableLibrary — the how-to video strip inside the availability pages.
 *   <VideoAvailableLibrary leg="staff" />       casual: Create Availability tab
 *   <VideoAvailableLibrary leg="supervisor" />  supervisor and above: Create Jobs tab
 * Same cards, horizontal scrolling, ‹ dots › row and modal player as the ProfileHome shelf
 * (VideoShelf); only the list (data/videoAvailableLibrary.js) and the accent differ — the
 * accent is the page's own, so the strip reads as part of the tab it sits in.
 */
const ACCENT = { staff: '#F97316', supervisor: '#22d3ee' };

const VideoAvailableLibrary = ({ leg }) => {
  const { user } = useUser();
  const shelves = useMemo(() => availableShelvesForUser(user, leg, { itemVisible }), [user, leg]);
  if (!shelves.length) return null;
  return <VideoShelf shelves={shelves} accent={ACCENT[leg] || ACCENT.staff} className={`val-root val-${leg}`} />;
};

export default VideoAvailableLibrary;
